/**
 * URL Constants for TuTiMi Application
 * Centralized location for all URLs, links, and external resources
 */

// ===== INTERNAL ROUTES =====
export const ROUTES = {
  HOME: "/",
  HETHONGCUAHANG: "/hethongcuahang",
  STORE_LOCATOR: "/stores",
  ABOUT: "/about",
  MENU: "/menu",
  PROMOTION: "/promotion",
  PARTNER: "/partner",
  CONTACT: "/contact",
  POLICY: "/policy",
  RECRUITMENT: "/recruitment",
  RECRUITMENT_DETAIL: "/recruitment/:jobId",
  NOT_FOUND: "*",
} as const

// ===== CONTACT INFORMATION =====
export const CONTACT = {
  PHONE: "0901837263",
  PHONE_URL: "tel:0901837263",
  PHONE_2: "0778676009",
  PHONE_2_URL: "tel:0778676009",
  EMAIL: "tutimicoffee@gmail.com",
  EMAIL_URL: "mailto:tutimicoffee@gmail.com",
  ADDRESS: "39/50 Đặng Thùy Trâm, P.13, Q. Bình Thạnh, TP.HCM",
} as const

// ===== SOCIAL MEDIA LINKS =====
export const SOCIAL_MEDIA = {
  FACEBOOK: {
    PAGE: "https://www.facebook.com/trasuatutimi?locale=vi_VN",
    RECRUITMENT: "https://www.facebook.com/tutimituyendung",
    EMBED:
      "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ftrasuatutimi&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
  },
  TIKTOK: "https://www.tiktok.com/@trasua.tutimi?_t=8l6JjVpehR1&_r=1",
} as const

// ===== GOOGLE MAPS =====
export const MAPS = {
  SEARCH_URL:
    "https://www.google.com/maps/search/TuTiMi+coffee+tea/@10.762622,106.660172,12z",
  EMBED_URL:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125398.90089094721!2d106.58017!3d10.762622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTDCsDQ1JzQ1LjQiTiAxMDbCsDM5JzM2LjYiRQ!5e0!3m2!1svi!2s!4v1711774711226!5m2!1svi!2s",
  STORE_SEARCH_URLS: {
    BINH_QUOI:
      "https://www.google.com/maps/search/129a+Bình+Quới,+Phường+27,+Quận+Bình+Thạnh,+TuTiMi",
    PHAN_VAN_TRI: "https://maps.app.goo.gl/ydJYi9CKA2PM9qAu5",
    NGUYEN_KIEM:
      "https://www.google.com/maps/search/376+Nguyễn+Kiệm,+Phường+3,+Quận+Phú+Nhuận,+TuTiMi",
    DINH_BO_LINH:
      "https://www.google.com/maps/search/141+Đinh+Bộ+Lĩnh,+Phường+26,+Quận+Bình+Thạnh,+TuTiMi",
    DUONG_SO_8: "https://maps.app.goo.gl/fTrCex537v6YWvDXA",
    NGO_TAT_TO:
      "https://www.google.com/maps/place/Tr%C3%A0+S%E1%BB%AFa+TuTiMi+-+71+Ng%C3%B4+T%E1%BA%A5t+T%E1%BB%91,+Ph%C6%B0%E1%BB%9Dng+21,+Qu%E1%BA%ADn+Bi%CC%80nh+Tha%CC%A3nh/@10.7928043,106.7116873,17z/data=!4m15!1m8!3m7!1s0x317528adf5866e8b:0x8ee1e1cc661b8d3b!2zNzEgxJAuIE5nw7QgVOG6pXQgVOG7kSwgUGjGsOG7nW5nIDE5LCBCw6xuaCBUaOG6oW5oLCBI4buTIENow60gTWluaA!3b1!8m2!3d10.7928043!4d106.7116873!16s%2Fg%2F11jzntfnqc!3m5!1s0x31752939b5ed2c27:0xf19d35f9ba47ab6b!8m2!3d10.7928025!4d106.7116893!16s%2Fg%2F11rfn2d8pd?entry=ttu&g_ep=EgoyMDI1MDYyOS4wIKXMDSoASAFQAw%3D%3D",
    VAN_KIEP: "https://maps.app.goo.gl/VUoLdtcw5nyi4FxDA",
    TAN_QUY:
      "https://www.google.com/maps/search/34c+Tân+Quý,+Phường+Tân+Quý,+Quận+Tân+Phú,+TuTiMi",
    DONG_DEN:
      "https://www.google.com/maps/search/39+Đồng+Đen,+Phường+12,+Quận+Tân+Bình,+TuTiMi",
    NGUYEN_VAN_QUA_71A:
      "https://www.google.com/maps/search/71a+Nguyễn+Văn+Quá,+Phường+Tân+Hưng+Thuận,+Quận+12,+TuTiMi",
    NGUYEN_ANH_THU:
      "https://www.google.com/maps/place/Tr%C3%A0+s%E1%BB%AFa+TuTiMi+-+34+Nguy%E1%BB%85n+%E1%BA%A2nh+Th%E1%BB%A7,+P.Hi%E1%BB%87p+Th%C3%A0nh,+Q.12/@10.8764109,106.6476466,17z/data=!4m15!1m8!3m7!1s0x317529e177be1a0b:0x1a5c0e9dbdd32512!2zMzQgxJAuIE5ndXnhu4VuIOG6om5oIFRo4bunLCBIaeG7h3AgVGjDoG5oLCBRdeG6rW4gMTIsIEjhu5MgQ2jDrSBNaW5o!3b1!8m2!3d10.8764109!4d106.6476466!16s%2Fg%2F11x8y3j4zh!3m5!1s0x317529de72319a7b:0x79c520b62596b7cf!8m2!3d10.8764132!4d106.6477234!16s%2Fg%2F11smmf374n?entry=ttu&g_ep=EgoyMDI1MDYyOS4wIKXMDSoASAFQAw%3D%3D",
    LAC_LONG_QUAN:
      "https://www.google.com/maps/search/712+Lạc+Long+Quân,+Phường+9,+Quận+Tân+Bình,+TuTiMi",
    DANG_THUY_TRAM:
      "https://www.google.com/maps/search/39/50+Đặng+Thuỳ+Trâm,+Phường+13,+Quận+Bình+Thạnh,+TuTiMi",
    QUANG_TRUNG:
      "https://www.google.com/maps/search/129+Quang+Trung,+Thị+Trấn+Hóc+Môn,+Huyện+Hóc+Môn,+TuTiMi",
    TINH_LO_10:
      "https://www.google.com/maps/search/329+Tỉnh+Lộ+10,+P.+An+Lạc,+Quận+Bình+Tân,+TuTiMi",
    HIEP_BINH: "https://maps.app.goo.gl/Ti1QUcUQseQ8c2Hi9",
    NGUYEN_DUY_TRINH: "https://maps.app.goo.gl/4KgPGDuN12uifkLa6",
    CACH_MANG_THANG_TAM:
      "https://www.google.com/maps/search/376d+Cách+Mạng+Tháng+Tám,+Phường+10,+Quận+3,+TuTiMi",
    DUONG_SO_17_THU_DUC: "https://maps.app.goo.gl/Ha3NGHRiBkRf4rwd6",
    TRUONG_SON:
      "https://www.google.com/maps/search/65+Trường+Sơn,+Phường+2,+Quận+Tân+Bình,+TuTiMi",
    DO_XUAN_HOP: "https://maps.app.goo.gl/6sA8cYtdwtV2JyTW6",
    DUONG_SO_3:
      "https://www.google.com/maps/search/59+Đường+Số+3,+Phường+An+Khánh,+Thành+Phố+Thủ+Đức,+TuTiMi",
    NGUYEN_TRI_PHUONG: "https://maps.app.goo.gl/CBRw7y1iUCcwVzy5A",
    VINH_HOI: "https://maps.app.goo.gl/2cZDcVB8QUv1vnS38",
    LE_VAN_QUOI: "https://maps.app.goo.gl/8J8MZ9CGqu41YWZS8",
    TAN_KIENG:
      "https://www.google.com/maps/search/26+Đường+Số+17,+Phường+Tân+Kiểng,+Quận+7,+TuTiMi",
    MAN_THIEN:
      "https://www.google.com/maps/search/45+Man+Thiện,+Phường+Tân+Hiệp+Phú,+Thành+Phố+Thủ+Đức,+TuTiMi",
    DANG_CHAT: "https://maps.app.goo.gl/h3VJ6qa8STd1Y4C97",
    HO_HOC_LAM: "https://maps.app.goo.gl/nmo6KqM1LxekMN5T6",
  },
} as const

// ===== WEBSITE INFORMATION =====
export const WEBSITE = {
  DOMAIN: "https://tutimi.com",
  TITLE: "TuTiMi Tea",
  DESCRIPTION:
    "Discover the tasty way to a healthier life with TuTiMi Tea's organic drinks. Mỗi giọt hạnh phúc, mỗi ly kết nối, hương thơm gắn kết.",
  KEYWORDS:
    "TuTiMi, tea, coffee, trà sữa, cà phê, organic drinks, healthy drinks, Vietnamese tea",
  AUTHOR: "@tutimi",
} as const

// ===== ASSETS PATHS =====
export const ASSETS = {
  LOGOS: {
    MAIN: "/logos/logo.png",
    HEADER: "/logos/logo-header.png",
  },
  PRODUCTS: {
    FEATURED_DRINK: "/products/SUA-TUOI-MATCHA-DUONG-DEN-3-600x600.png",
  },
} as const

export const RECRUITMENT = {
  HRM: "https://hrm.tutimi.com.vn/recruitment?company=TUTIMI",
  HRM_BASE: "https://hrm.tutimi.com.vn",
  API_BASE: "https://api.tutimi.com.vn/api/hrm/v1",
} as const

// ===== EXTERNAL LINKS =====
export const EXTERNAL_LINKS = {
  ORDER_NOW: SOCIAL_MEDIA.FACEBOOK.PAGE,
} as const

// ===== HELPER FUNCTIONS =====
// No helper functions needed for simplified routing

// ===== TYPE EXPORTS =====
export type RouteKey = keyof typeof ROUTES
export type ContactKey = keyof typeof CONTACT
export type SocialMediaKey = keyof typeof SOCIAL_MEDIA
